import AdminLogin from './adminLogin';
export default AdminLogin;